import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { getTemporaryAuthToken } from '../../../utils/localStorage';

// OTP
export const ACTION_REQUEST_VERIFY_OTP = 'ACTION_REQUEST_VERIFY_OTP';
export const REQUEST_VERIFY_OTP = 'REQUEST_VERIFY_OTP';
export const REQUEST_VERIFY_OTP_SUCCESS = 'REQUEST_VERIFY_OTP_SUCCESS';
export const REQUEST_VERIFY_OTP_FAILURE = 'REQUEST_VERIFY_OTP_FAILURE';

// RESEND CODE
export const ACTION_REQUEST_RESEND_CODE = 'ACTION_REQUEST_RESEND_CODE';
export const REQUEST_RESEND_OTP = 'REQUEST_RESEND_OTP';
export const REQUEST_RESEND_OTP_SUCCESS = 'REQUEST_RESEND_OTP_SUCCESS';
export const REQUEST_RESEND_OTP_FAILURE = 'REQUEST_RESEND_OTP_FAILURE';

const defaultState = {
  // OTP verification
  verifyOTPRequesting: false,
  verifyOTPFailure: false,
  verifyOTPSuccess: false,

  // RESEND
  resendCodeRequesting: false,
  resendCodeFailure: false,
  resendCodeSuccess: false,
};

const reducer = createReducer(defaultState, {
  // VERIFY OTP
  [REQUEST_VERIFY_OTP]: (state) => ({
    ...state,
    verifyOTPRequesting: true,
    verifyOTPFailure: false,
    verifyOTPSuccess: false,
  }),
  [REQUEST_VERIFY_OTP_SUCCESS]: (state) => {
    return {
      ...state,
      verifyOTPFailure: false,
      verifyOTPSuccess: true,
      verifyOTPRequesting: false,
    };
  },
  [REQUEST_VERIFY_OTP_FAILURE]: (state) => {
    return {
      ...state,
      verifyOTPFailure: true,
      verifyOTPRequesting: false,
      verifyOTPSuccess: false,
    };
  },

  // RESEND OTP
  [REQUEST_RESEND_OTP]: (state) => ({
    ...state,
    resendCodeRequesting: true,
    resendCodeSuccess: false,
    resendCodeFailure: false,
  }),
  [REQUEST_RESEND_OTP_SUCCESS]: (state) => {
    return {
      ...state,
      resendCodeFailure: false,
      resendCodeSuccess: true,
      resendCodeRequesting: false,
    };
  },
  [REQUEST_RESEND_OTP_FAILURE]: (state) => {
    return {
      ...state,
      resendCodeFailure: true,
      resendCodeRequesting: false,
      resendCodeSuccess: false,
    };
  },
});

export default reducer;
export const namespace = 'otpVerification';

export const verifyOTPAction = (credentials) => ({
  type: ACTION_REQUEST_VERIFY_OTP,
  payload: credentials,
});

export const verifyOTPAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/verify-account',
    actionTypes: [REQUEST_VERIFY_OTP, REQUEST_VERIFY_OTP_SUCCESS, REQUEST_VERIFY_OTP_FAILURE],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
    headers: {
      Authorization: `Bearer ${getTemporaryAuthToken()}`,
    },
  });
};

export const resendOTPAction = (credentials) => ({
  type: ACTION_REQUEST_RESEND_CODE,
  payload: credentials,
});

export const resendOTPAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/resend-verification-email',
    actionTypes: [REQUEST_RESEND_OTP, REQUEST_RESEND_OTP_SUCCESS, REQUEST_RESEND_OTP_FAILURE],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};
